<template>
  <div>
    <v-btn color="admin" dark outlined @click="onImport"> <v-icon left>mdi-upload</v-icon>Nhập Excel </v-btn>
    <ImportDialog ref="import-dialog" @onRefresh="onRefresh" />
  </div>
</template>
<script>
import ImportDialog from './ImportDialog.vue'
export default {
  components: {ImportDialog},
  methods: {
    onImport() {
      this.$refs['import-dialog'].openDialog()
    },
    onRefresh() {
      this.$emit('onRefresh')
    },
  },
}
</script>